import { Injectable } from '@angular/core';
import { ClientData } from './models/ClientData';
import { UserData } from './models/UserData';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    clientData: ClientData = {
        ClientID: 'PH.Observe.Mobile',
    };
    userData: UserData;
    institutions: string;
    institutionConfig: any;
}
